import React from 'react';
import heroImage from '../../../assets/images/team_screen/hero_img.jpeg';
import { scrollToSpecificSection } from '../../../utils';

const HeroSection = () => {
  const teamLinks = [
    { name: 'Mary', link: 'mary' },
    { name: 'Jessica', link: 'jessica' },
    { name: 'Rebecca', link: 'rebecca' },
    { name: 'Julia', link: 'julia' },
    { name: 'Michele', link: 'michele' },
    { name: 'Jenny', link: 'jenny' },
    // { name: 'Whitney', link: 'whitney' },
    { name: 'Kerrie', link: 'kerrie' },
    { name: 'Renj', link: 'renj' },
    { name: 'Selina', link: 'selina' },
    // { name: "Melissa", link: "melissa" },
    { name: 'Lynne', link: 'lynne' },
    { name: 'Palmer', link: 'palmer' },
    // { name: "Susan", link: "susan" },
  ];

  return (
    <div
      className="w-full h-[350px] md:h-[550px] 2xl:h-[600px] 4xl:h-[750px] 5xl:h-[850px] 3xl:h-[700px] bg-cover bg-center relative z-20"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="absolute top-0 left-0 w-full h-full" />

      <div className="absolute top-0 left-0 w-full px-4 py-2 bg-headerBg/90 xs:py-4 xs:pb-4 sm:pb-1">
        <div className="flex items-start md:items-center flex-col lg:flex-row lg:gap-10 justify-normal lg:justify-between  max-w-[1200px] 3xl:max-w-[1500px] mx-auto">
          <h1 className="text-white text-[20px] md:text-[28px] lg:text-[38px] 2xl:text-[40px] 3xl:text-[53px] font-[700] tracking-wide">
            Our Team
          </h1>
          <div className="flex flex-wrap items-center gap-4 mt-3 sm:gap-6 md:gap-8">
            {teamLinks.map((item, index) => {
              return (
                <p
                  onClick={() => scrollToSpecificSection(item.link, 150)}
                  key={index}
                  className="text-sm text-white cursor-pointer sm:text-md 2xl:text-2xl"
                >
                  {item.name}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
